import { createContext, useContext, useState, type ReactNode } from 'react';

type DatevAuthStatus = {
  authorized: boolean;
  expiresAt: string;
  name: string;
  beraternummer: string;
  mandantennummer: string;
} | null;

type DatevAuthContextValue = {
  status: DatevAuthStatus;
  setStatus: (status: DatevAuthStatus) => void;
};

const DatevAuthContext = createContext<DatevAuthContextValue | undefined>(
  undefined,
);

export function DatevAuthProvider({ children }: { children: ReactNode }) {
  const [status, setStatus] = useState<DatevAuthStatus>(null);

  return (
    <DatevAuthContext.Provider value={{ status, setStatus }}>
      {children}
    </DatevAuthContext.Provider>
  );
}

// oxlint-disable-next-line react/only-export-components
export function useDatevAuthContext(): DatevAuthContextValue {
  const context = useContext(DatevAuthContext);

  if (context === undefined) {
    throw new Error(
      'useDatevAuthContext must be used within a DatevAuthProvider',
    );
  }

  return context;
}
